import { protectedReq, request } from "../helpers/requestHelper";

// validar token de sesión
export const getSession = async (setItem) => {
    try {
        const resp = await protectedReq('sso/get-session');
        const body = await resp.json();
        if (body.status) {
            const { email, username } = body.resp;
            setItem(e => ({ ...e, email, username, loadingSession: false }));
        } else {
            if (checkUserSession(body.msg, setItem))
                setItem(e => ({ ...e, loadingSession: false }));
        }
    } catch (err) {
        setItem(e => ({ ...e, loadingSession: false }));
    };
};

// guardar token de sesión e información de usuario iniciado
export const oauthToken = async (code, setItem) => {
    try {
        const resp = await request('sso/oauth-token', { code }, 'POST');
        const body = await resp.json();
        if (body.status) {
            const { email, username, token, expires_in, device_id } = body.resp;
            localStorage.setItem('token', token);
            localStorage.setItem('expires_at', Date.now() + expires_in * 1000);
            localStorage.setItem('device_id', device_id);
            setItem(e => ({ ...e, email, username }));
        }
        return body;
    } catch (err) {
        return { status: false, mgs: 'site-err' };
    };
};

// validar sesión de usuario
export const checkUserSession = (msg, setItem) => {
    if (['unavailable-token', 'invalid-token', 'token-expired'].includes(msg)) {
        localStorage.removeItem('token');
        setItem(e => ({ ...e, email: '', username: '', loadingSession: false }));
        return false;
    } else return true;
};